module.exports = __webpack_public_path__ + "img/logo-endesa-x.13fe4ebb.png";